import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentforevetsinpune() {


const cardData = {
keyword: "Bus on Rent For Event in Pune",
headingDescription: "Ruturaj Enterprises offers Bus on Rent For Event in Pune for organizations, families, institutions, event planners, and private groups looking for convenient transportation for different types of gatherings. Whether the requirement is for a corporate event, wedding celebration, exhibition, conference, festival, private function, or large group program, suitable buses can be arranged according to passenger strength, event venue, pickup locations, journey distance, timing, and travel preferences.",
topPlaces: [
{
title: "Swargate",
description: "Swargate is an important transportation and commercial area of Pune with access to several residential and business zones. Event bus arrangements from this area can help groups travel together to wedding venues, exhibitions, conferences, festivals, and other scheduled events."
},
{
title: "Kondhwa",
description: "Kondhwa has a combination of residential communities, hotels, restaurants, and function venues that can be included in event transportation plans. A dedicated bus can collect guests from selected locations and transport them to event venues according to the planned schedule."
},
{
title: "Wagholi",
description: "Wagholi is a growing residential and commercial area with hotels, event spaces, and business establishments. Group event transportation can be arranged for employees, families, guests, and participants traveling from Wagholi toward venues across Pune and nearby destinations."
},
{
title: "Yerawada",
description: "Yerawada provides convenient access toward several commercial, airport, and central Pune locations where corporate and social events are held. Dedicated buses can assist with organized transportation for conference attendees, business groups, wedding guests, and private event participants."
},
{
title: "Pashan",
description: "Pashan and nearby areas have residential communities, hotels, restaurants, and facilities used for different gatherings. Event transportation from this locality can help groups travel together to functions, corporate programs, conferences, celebrations, and other planned activities."
},
{
title: "Katraj",
description: "Katraj is a well-connected southern part of Pune and can be useful as a pickup area for groups traveling toward different event destinations. Bus rental provides an organized option for families, corporate teams, wedding guests, and participants attending events together."
},
{
title: "Bavdhan",
description: "Bavdhan connects residential areas with several commercial and recreational destinations around Pune. Dedicated event buses can support transportation for private celebrations, corporate gatherings, family functions, and organized group programs."
},
{
title: "Pirangut",
description: "Pirangut is surrounded by industrial, educational, residential, and recreational developments, creating requirements for organized group transportation. Event buses can help employees, families, students, and participants reach venues from planned pickup points."
},
{
title: "Talegaon",
description: "Talegaon has industrial areas, residential communities, hotels, and event-related facilities that may be included in group travel plans. A dedicated bus provides a convenient transportation arrangement for corporate events, private functions, family gatherings, and organized programs."
},
{
title: "Bhosari",
description: "Bhosari is an important industrial and commercial locality with a large workforce and surrounding residential areas. Event bus services can help companies and groups coordinate transportation for corporate programs, exhibitions, business gatherings, celebrations, and other events."
}
],
services: [
{
name: "Event Bus Rental Pune",
description: "Event Bus Rental Pune provides dedicated transportation for conferences, weddings, corporate gatherings, exhibitions, festivals, private celebrations, and other organized programs. Ruturaj Enterprises can arrange a suitable bus based on the number of attendees, event venue, pickup points, route, timing, and travel duration."
},
{
name: "Event Bus Hire Pune",
description: "Event Bus Hire Pune is a convenient option for organizers who need to transport guests, employees, families, or participants to a common destination. A dedicated bus helps reduce the need for multiple cars and allows the group to follow a coordinated travel schedule."
},
{
name: "Event Bus Booking Pune",
description: "Event Bus Booking Pune can be planned for upcoming corporate functions, weddings, exhibitions, conferences, festivals, family gatherings, and private events. Advance planning makes it easier to determine seating capacity, pickup locations, reporting time, venue route, waiting requirements, and return transportation."
},
{
name: "AC Bus for Events Pune",
description: "AC Bus for Events Pune provides a comfortable travel solution for attendees traveling to local events or destinations outside Pune. Air-conditioned buses can be considered for conferences, weddings, corporate programs, exhibitions, festivals, and longer event-related journeys."
},
{
name: "Luxury Bus Rental for Events Pune",
description: "Luxury Bus Rental for Events Pune is suitable when event organizers need premium group transportation for executives, VIP guests, clients, wedding parties, or special attendees. It can be arranged for corporate functions, destination events, receptions, conferences, and important group occasions."
},
{
name: "Bus for Corporate Events Pune",
description: "Bus for Corporate Events Pune supports transportation for employees, management teams, clients, delegates, and business guests attending company programs. Dedicated buses can be used for annual functions, seminars, product launches, conferences, exhibitions, team events, and corporate celebrations."
},
{
name: "Bus for Wedding Events Pune",
description: "Bus for Wedding Events Pune is designed for transporting relatives, friends, family members, and invited guests during wedding celebrations. It can support movement between homes, hotels, banquet halls, marriage venues, reception locations, and other functions included in the wedding schedule."
},
{
name: "Event Transportation Bus Pune",
description: "Event Transportation Bus Pune offers organized group travel for participants attending scheduled events and functions. Transportation can be structured around the venue location, passenger count, pickup points, event timings, accommodation requirements, and return journey."
},
{
name: "Group Event Bus Rental Pune",
description: "Group Event Bus Rental Pune is useful when a large number of attendees need to travel to the same venue. A suitable-capacity bus allows corporate teams, families, event participants, wedding guests, and private groups to travel together with easier coordination."
},
{
name: "Event Guest Transportation Pune",
description: "Event Guest Transportation Pune helps organizers manage the movement of attendees arriving from different areas, hotels, offices, residential locations, or transportation hubs. Dedicated buses can be scheduled for venue arrival as well as post-event transportation."
},
{
name: "Bus for Exhibition Pune",
description: "Bus for Exhibition Pune provides group transportation for exhibitors, employees, visitors, business representatives, and organized teams attending exhibitions. Travel can be coordinated according to exhibition timings, office pickup points, hotel locations, reporting schedules, and return requirements."
},
{
name: "Bus for Conference Pune",
description: "Bus for Conference Pune is suitable for transporting delegates, employees, speakers, clients, and business visitors to conference venues. Dedicated buses can connect hotels, offices, airports, and meeting points with the conference location according to the planned event itinerary."
},
{
name: "Bus for Festival Events Pune",
description: "Bus for Festival Events Pune supports group travel for cultural celebrations, community programs, seasonal festivals, entertainment events, and organized gatherings. A dedicated bus provides a practical way for groups to travel together from selected pickup points to the event venue."
},
{
name: "Affordable Event Bus Rental Pune",
description: "Affordable Event Bus Rental Pune provides a practical transportation option for organizers managing event travel expenses. Choosing an appropriately sized bus can simplify transportation for larger groups while reducing the need to coordinate numerous individual vehicles."
},
{
name: "Event Guest Pickup Bus Pune",
description: "Event Guest Pickup Bus Pune helps organizers collect attendees from hotels, homes, offices, railway stations, or designated meeting points. Pickup arrangements can be structured around guest locations and the required arrival time at the event venue."
},
{
name: "Event Guest Drop Bus Pune",
description: "Event Guest Drop Bus Pune provides organized transportation after weddings, conferences, exhibitions, festivals, corporate functions, and private events. Guests can be transported to selected hotels, homes, parking locations, or other designated drop points after the program."
},
{
name: "Event Shuttle Bus Pune",
description: "Event Shuttle Bus Pune is useful when attendees require repeated movement between hotels, parking facilities, event venues, offices, and activity areas. Shuttle schedules can be planned around event timings and attendee movement throughout the day."
},
{
name: "Event Venue Transportation Pune",
description: "Event Venue Transportation Pune helps connect guests and participants with banquet halls, hotels, convention centers, exhibition grounds, resorts, corporate campuses, and other event locations. Dedicated buses can cover planned pickup points and venue transfers according to the event schedule."
},
{
name: "Corporate Event Bus Hire Pune",
description: "Corporate Event Bus Hire Pune provides transportation for employees, executives, clients, delegates, and business guests attending company events. It can be arranged for seminars, conferences, annual functions, exhibitions, product launches, team gatherings, and corporate celebrations."
},
{
name: "Private Event Bus Rental Pune",
description: "Private Event Bus Rental Pune is suitable for families, communities, clubs, organizations, and private groups planning celebrations or gatherings. A dedicated vehicle allows the group to follow its own travel schedule and coordinate transportation according to the selected venue and pickup points."
},
{
name: "Event Group Transportation Pune",
description: "Event Group Transportation Pune supports organized travel for larger groups attending social, corporate, cultural, recreational, private, and family events. Vehicle selection can be based on passenger numbers, destination, event duration, pickup requirements, and preferred travel comfort."
},
{
name: "AC Event Bus Rental Pune",
description: "AC Event Bus Rental Pune provides air-conditioned transportation for groups traveling to events within Pune as well as longer-distance programs. It can be used for corporate gatherings, weddings, conferences, exhibitions, festivals, private celebrations, and organized group functions."
}
],
tableData: [
["Event Bus Rental Pune", "Event Bus Hire Pune"],
["Event Bus Booking Pune", "AC Bus for Events Pune"],
["Luxury Bus Rental for Events Pune", "Bus for Corporate Events Pune"],
["Bus for Wedding Events Pune", "Event Transportation Bus Pune"],
["Group Event Bus Rental Pune", "Event Guest Transportation Pune"],
["Bus for Exhibition Pune", "Bus for Conference Pune"],
["Bus for Festival Events Pune", "Affordable Event Bus Rental Pune"],
["Event Guest Pickup Bus Pune", "Event Guest Drop Bus Pune"],
["Event Shuttle Bus Pune", "Event Venue Transportation Pune"],
["Corporate Event Bus Hire Pune", "Private Event Bus Rental Pune"],
["Event Group Transportation Pune", "AC Event Bus Rental Pune"]
],
whychoose: [
{
WhyChooseheading: "Easy Group Event Management",
WhyChoosedescription: "Managing transportation for a large event can become complicated when every participant uses a separate vehicle. A dedicated bus creates a common travel arrangement that helps organizers coordinate guests, employees, families, and participants more efficiently."
},
{
WhyChooseheading: "Transportation for Multiple Event Types",
WhyChoosedescription: "Different events require different transportation arrangements, from corporate conferences and exhibitions to weddings, festivals, and private celebrations. Ruturaj Enterprises supports varied event requirements according to passenger strength, destination, venue, and schedule."
},
{
WhyChooseheading: "Planned Guest Pickup",
WhyChoosedescription: "Guests may arrive from several hotels, residential areas, offices, or designated meeting locations. Pickup routes can be planned around selected points so attendees can reach the venue together and according to the required reporting time."
},
{
WhyChooseheading: "Comfortable AC Travel",
WhyChoosedescription: "Air-conditioned buses provide a comfortable option for guests traveling during warm weather or covering longer distances. They are suitable for conferences, weddings, corporate events, exhibitions, festivals, and destination-based programs."
},
{
WhyChooseheading: "Premium Event Transportation",
WhyChoosedescription: "Some events require a more polished travel experience for executives, VIP guests, clients, or special invitees. Luxury bus options can provide an appropriate group transportation solution for corporate programs, weddings, conferences, and important celebrations."
},
{
WhyChooseheading: "Convenient Shuttle Operations",
WhyChoosedescription: "Large events may require multiple transfers throughout the day between hotels, parking areas, offices, and venues. Shuttle bus arrangements can be planned around attendee movement and event schedules to support convenient transportation during different stages of the program."
},
{
WhyChooseheading: "Suitable for Large Groups",
WhyChoosedescription: "When dozens of people need to reach the same destination, arranging separate cars can increase coordination and parking requirements. A suitable-capacity event bus keeps the group together and provides a more organized way to manage event transportation."
},
{
WhyChooseheading: "Flexible Event Travel Plans",
WhyChoosedescription: "Ruturaj Enterprises can support event transportation based on passenger count, venue location, pickup points, route, event timings, travel distance, and preferred bus type. This makes the service suitable for short local programs as well as longer destination events."
}
]
};













const faqData = [
{
question: "Why choose Ruturaj Enterprises for a bus on rent for events in Pune?",
answer: "Ruturaj Enterprises provides bus rental solutions for different types of events where organized group transportation is required. A suitable bus can help transport guests, employees, participants, families, or event teams between pickup points, hotels, venues, railway stations, airports, and other locations."
},
{
question: "What types of events can use a rental bus in Pune?",
answer: "Rental buses can be arranged for weddings, corporate events, exhibitions, conferences, seminars, cultural programs, family functions, school events, college gatherings, religious programs, social celebrations, and group tours. The vehicle can be selected according to the event size and passenger requirements."
},
{
question: "Can I rent a bus for wedding events in Pune?",
answer: "Wedding organizers and families can hire a bus to transport relatives and guests between homes, hotels, marriage halls, banquet venues, reception locations, railway stations, and airports. Group transportation can make guest movement easier to coordinate throughout the celebrations."
},
{
question: "Can companies book a bus for corporate events?",
answer: "Businesses can arrange rental buses for conferences, seminars, product launches, annual functions, employee gatherings, team outings, training programs, and corporate celebrations. A dedicated vehicle can help move employees, delegates, and participants according to the event schedule."
},
{
question: "What bus capacity is suitable for an event?",
answer: "The appropriate seating capacity depends on the number of people attending the event and the planned transportation requirements. Ruturaj Enterprises can arrange different group vehicle options, including 20, 26, 32, 35, 45, and 50 Seater Buses for various event sizes."
},
{
question: "Can I book a bus for guests coming from outside Pune?",
answer: "Event organizers can arrange transportation for guests arriving from other cities and coordinate their travel to hotels, venues, or designated gathering points. Pickup and drop schedules can be planned according to arrival details and the overall event itinerary."
},
{
question: "Can a rental bus be used for multiple event venues?",
answer: "A bus can be scheduled to transport participants between multiple venues when the complete itinerary is shared in advance. This can be useful for events involving separate registration locations, accommodation, main venues, dining areas, and other scheduled activities."
},
{
question: "Can I hire a bus for exhibitions and conferences in Pune?",
answer: "Exhibition organizers, conference teams, and event planners can use rental buses to transport attendees, staff, delegates, or business groups. Group transportation can be coordinated between hotels, offices, exhibition grounds, conference centers, and other event-related locations."
},
{
question: "Is bus rental suitable for large family and social events?",
answer: "Family celebrations, reunions, religious gatherings, cultural programs, and social events can benefit from dedicated group transportation. A suitable bus allows multiple participants to travel together and reduces the need to coordinate several separate vehicles during the event."
},
{
question: "How can I book a bus on rent for an event in Pune?",
answer: "To arrange event transportation with Ruturaj Enterprises, provide the event date, pickup points, destination or venues, number of passengers, required bus capacity, timings, and trip duration. Sharing the complete schedule helps in planning the rental around the event's transportation needs."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Kunal Deshmukh",
feedback:
"We rented a bus from Ruturaj Enterprises for a large family event in Pune. Transporting guests between the hotel and event venue was much easier with everyone traveling together. The arrangement helped us manage the guest movement smoothly throughout the function.",
rating: 5
},
{
id: 2,
name: "Miss. Anjali Bhosale",
feedback:
"Our team booked a bus from Ruturaj Enterprises for a corporate event. Having dedicated transportation for the employees made the movement between the office and event venue simple to coordinate. The bus rental was a practical choice for our group and schedule.",
rating: 5
}
];























    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus on Rent For Event in Pune",
  "image": "https://ruturajenterprises.com/assets/images/bus-on-rent-for-event-in-pune.webp",
  "description":
    "Bus on Rent For Event in Pune from Ruturaj Enterprises is a convenient group transportation solution for corporate events, weddings, exhibitions, conferences, seminars, cultural programs, college functions, social gatherings and other organized events. Event Bus Rental Pune can be arranged for transporting guests, employees, delegates, performers, students and event participants between hotels, offices, venues, airports, railway stations and designated pickup points. Event Bus Hire Pune is suitable for one-day programs, full-day events, multi-day functions, conferences, exhibitions, festivals and customized event schedules. Event Bus Booking Pune can be planned according to the event date, passenger count, pickup locations, destination, route and required travel duration. AC Bus for Events Pune provides a comfortable option for guest and participant transportation, while Luxury Bus Rental for Events Pune can be selected for premium corporate programs, weddings, special celebrations, conferences and important gatherings. Bus for Corporate Events Pune is useful for employee transportation, team outings, annual functions, conferences, seminars, training programs, exhibitions and business events. Bus for Wedding Events Pune can support guest transfers between hotels, marriage venues, banquet halls, resorts, reception locations and other event points. Event Guest Transportation Pune can be organized for large groups travelling together, reducing the need for multiple smaller vehicles and simplifying event logistics. Shuttle bus arrangements can also be planned for repeated transfers between parking areas, accommodation facilities and event venues. Seating capacities including 20 Seater, 26 Seater, 32 Seater, 35 Seater, 45 Seater and 50 Seater buses can be considered according to passenger requirements and availability. The service is also suitable for college events, school functions, sports events, cultural programs, religious gatherings, trade exhibitions, product launches, entertainment programs and large social occasions. Corporate and event transportation can be arranged across Pune and Pimpri-Chinchwad, including Kothrud, Baner, Aundh, Wakad, Hinjewadi, Viman Nagar, Kharadi, Hadapsar, Magarpatta, Kalyani Nagar, Yerawada, Shivajinagar, Swargate, Kondhwa, Katraj, Pimpri, Chinchwad, Bhosari, Moshi and Talegaon. Outstation event transportation can also be arranged for Mumbai, Lonavala, Mahabaleshwar, Nashik, Kolhapur, Satara, Goa, Konkan and other destinations depending on the event itinerary. Airport pickup and drop services can be coordinated for visiting guests, delegates and participants. Ruturaj Enterprises supports local, full-day, multi-day and outstation event bus rental requirements with customized transportation plans based on passenger capacity, venue locations and event schedules.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/bus-on-rent-for-event-in-pune"
  }
};







    return (
        <div>
<Helmet>
  <title>Bus on Rent For Event in Pune | Event Bus Rental Pune | +91 9763381382</title>

  <meta
    name="description"
    content="Bus on Rent For Event in Pune for corporate events, weddings, conferences, exhibitions, cultural programs, college functions and large group transportation."
  />

  <meta
    name="keywords"
    content="Event Bus Rental Pune, Event Bus Hire Pune, Event Bus Booking Pune, AC Bus for Events Pune, Luxury Bus Rental for Events Pune, Bus for Corporate Events Pune, Bus for Wedding Events Pune, Bus on Rent For Event in Pune, Event Bus on Rent Pune, Event Transportation Bus Pune, Event Group Transportation Pune, Event Guest Transportation Pune, Event Guest Bus Rental Pune, Event Guest Bus Hire Pune, Event Guest Bus Booking Pune, Event Shuttle Bus Pune, Event Shuttle Bus Rental Pune, Event Shuttle Service Pune, Event Transportation Service Pune, Event Bus Service Pune, Event Bus with Driver Pune, Private Event Bus Pune, AC Event Bus Rental Pune, Luxury Event Bus Hire Pune, Premium Event Bus Pune, Comfortable Event Bus Pune, Affordable Event Bus Rental Pune, Large Event Bus Rental Pune, Corporate Event Bus Rental Pune, Corporate Event Bus Hire Pune, Corporate Event Bus Booking Pune, Corporate Event Transportation Pune, Corporate Function Bus Rental Pune, Corporate Function Bus Hire Pune, Corporate Meeting Bus Pune, Corporate Conference Bus Pune, Corporate Seminar Bus Pune, Corporate Exhibition Bus Pune, Corporate Training Event Bus Pune, Corporate Outing Bus Pune, Corporate Team Event Bus Pune, Corporate Annual Function Bus Pune, Company Event Bus Rental Pune, Company Event Transportation Pune, Business Event Bus Pune, Business Event Transportation Pune, Conference Bus Rental Pune, Conference Bus Hire Pune, Conference Transportation Pune, Seminar Bus Rental Pune, Seminar Bus Hire Pune, Seminar Transportation Pune, Exhibition Bus Rental Pune, Exhibition Bus Hire Pune, Exhibition Transportation Pune, Trade Show Bus Rental Pune, Product Launch Bus Rental Pune, Product Launch Event Transportation Pune, Wedding Event Bus Rental Pune, Wedding Event Bus Hire Pune, Wedding Guest Event Transportation Pune, Marriage Event Bus Rental Pune, Marriage Event Bus Hire Pune, Wedding Reception Bus Pune, Wedding Function Bus Pune, Wedding Shuttle Bus Pune, Marriage Function Bus Pune, Marriage Ceremony Bus Pune, College Event Bus Rental Pune, College Function Bus Pune, College Festival Bus Rental Pune, School Event Bus Rental Pune, School Function Bus Pune, Sports Event Bus Rental Pune, Sports Team Bus Pune, Cultural Event Bus Rental Pune, Cultural Program Bus Pune, Festival Event Bus Rental Pune, Religious Event Bus Pune, Religious Gathering Bus Pune, Social Event Bus Rental Pune, Party Event Bus Rental Pune, Group Event Bus Rental Pune, Event Bus for Large Group Pune, Event Bus for Guests Pune, Event Bus for Participants Pune, Event Bus for Employees Pune, Event Bus for Delegates Pune, Event Bus for Students Pune, 20 Seater Event Bus Pune, 26 Seater Event Bus Pune, 32 Seater Event Bus Pune, 35 Seater Event Bus Pune, 45 Seater Event Bus Pune, 50 Seater Event Bus Pune, 20 Seater Event Bus Rental Pune, 32 Seater Event Bus Rental Pune, 35 Seater Event Bus Rental Pune, 45 Seater Event Bus Rental Pune, 50 Seater Event Bus Rental Pune, Event Bus Full Day Rental Pune, Event Bus Multi Day Rental Pune, Event Bus Weekend Rental Pune, Event Bus Outstation Rental Pune, Event Bus for Outstation Event Pune, Event Bus for Airport Transfer Pune, Event Bus for Airport Pickup Pune, Event Bus for Airport Drop Pune, Event Bus for Railway Station Transfer Pune, Event Bus for Hotel Transfer Pune, Event Bus for Resort Transfer Pune, Event Hotel Shuttle Bus Pune, Event Venue Shuttle Bus Pune, Event Parking Shuttle Bus Pune, Event Venue Transportation Pune, Event Hotel Transportation Pune, Event Airport Transportation Pune, Event Bus Rental Near Pune, Event Bus Hire Near Pune, Event Bus Booking Near Pune, Event Bus Rental Pimpri Chinchwad, Event Bus Rental Kothrud, Event Bus Rental Baner, Event Bus Rental Aundh, Event Bus Rental Wakad, Event Bus Rental Hinjewadi, Event Bus Rental Viman Nagar, Event Bus Rental Kharadi, Event Bus Rental Hadapsar, Event Bus Rental Magarpatta, Event Bus Rental Kalyani Nagar, Event Bus Rental Yerawada, Event Bus Rental Shivajinagar, Event Bus Rental Swargate, Event Bus Rental Kondhwa, Event Bus Rental Katraj, Event Bus Rental Pimpri, Event Bus Rental Chinchwad, Event Bus Rental Bhosari, Event Bus Rental Moshi, Event Bus Rental Talegaon"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/18.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Busonrentforevetsinpune;